module.exports = __webpack_public_path__ + "static/media/name-logo-white-1.991120a1.png";